import React, { useState, useLayoutEffect, useContext } from 'react';
import { MdDelete, MdEdit } from 'react-icons/md';

import * as S from './styles';
import { color } from 'styles/pallete';
import { DataFormProps, Link } from 'types/InputsRedirectableLinkProps';
import AddBtn from 'components/AddBtn';
import { returListOptionsDynamicPage } from './functions';
import DynamicPageContext from 'context/DynamicPage';
import FormRedirectableLink from 'components/FormRedirectableLink';
import { SelectInputItemProps } from 'types/SelectInputItemProps';

interface AddRedirectableLinkProps {
	dataForm: DataFormProps;
	setDataForm: React.Dispatch<React.SetStateAction<DataFormProps>>;
	isShow: boolean;
}

export default function AddRedirectableLink({
	isShow,
	dataForm,
	setDataForm
}: AddRedirectableLinkProps) {
	const { dynamicPagesList } = useContext(DynamicPageContext);

	const [isOpenFormLink, setIsOpenFormLink] = useState(false);
	const [linkToEdit, setLinkToEdit] = useState<Link | null>(null);
	const [optionsDynamicScreen, setOptionsDynamicScreen] = useState<
		SelectInputItemProps[]
	>([]);

	function returnNameRedirectByIdDynamicScreen(id: string) {
		const item = optionsDynamicScreen.filter((item) => item.id === id);
		return item.length > 0 ? item[0].option : 'Não encontrado';
	}

	function deleteLinkFromList(id: string) {
		const newList = dataForm.links.filter((item) => item.idFront !== id);
		setDataForm((obj) => ({ ...obj, links: newList }));
	}

	function addNewLink(newLink: Link) {
		setDataForm((obj) => ({ ...obj, links: [...obj.links, newLink] }));
		setIsOpenFormLink(false);
	}

	function editLink(linkEdited: Link) {
		const newList = dataForm.links.map((item) => {
			if (item.idFront === linkToEdit?.idFront) {
				return { ...item, ...linkEdited };
			}

			return item;
		});
		setDataForm((obj) => ({ ...obj, links: newList }));
		setIsOpenFormLink(false);
		setLinkToEdit(null);
	}

	//cria lista de opções de pagínas dinamicas em um estado para evitar reenderização
	useLayoutEffect(() => {
		setOptionsDynamicScreen(returListOptionsDynamicPage(dynamicPagesList));
	}, []);

	return (
		<S.container $isShow={isShow}>
			<AddBtn
				text="Adicionar link"
				anyFunction={() => setIsOpenFormLink(true)}
			/>
			<S.listLinks>
				{dataForm.links.length > 0 ? (
					dataForm.links.map((item) => (
						<S.link key={item.idFront}>
							<S.content>
								<p>
									<b>Nome: </b>
									{item.name}
								</p>
								<p>
									<b>Tipo de redirecionamento: </b>
									{item.redirect.type}
								</p>
								<p>
									<b>Valor: </b>
									{item.redirect.type === 'app_screen'
										? returnNameRedirectByIdDynamicScreen(item.redirect.value)
										: item.redirect.value}
								</p>
							</S.content>

							<S.actions>
								<MdDelete
									onClick={() => deleteLinkFromList(item.idFront)}
									color={color.system.error}
								/>
								<MdEdit
									onClick={() => {
										setIsOpenFormLink(true);
										setLinkToEdit(item);
									}}
									color={color.interface.darkgray3}
								/>
							</S.actions>
						</S.link>
					))
				) : (
					<S.noBanner>
						<p>Não há links cadastrado</p>
					</S.noBanner>
				)}
			</S.listLinks>
			{isOpenFormLink && (
				<FormRedirectableLink
					functionToGetDataAboutLink={
						linkToEdit === null ? addNewLink : editLink
					}
					isOpen={isOpenFormLink}
					setIsOpen={setIsOpenFormLink}
					linkToEdit={linkToEdit}
					setLinkToEdit={setLinkToEdit}
					optionsDynamicScreen={optionsDynamicScreen}
				/>
			)}
		</S.container>
	);
}
